import { render, staticRenderFns } from "./mis-datos-familiares.vue?vue&type=template&id=af73555c&scoped=true"
import script from "./mis-datos-familiares.vue?vue&type=script&lang=js"
export * from "./mis-datos-familiares.vue?vue&type=script&lang=js"
import style0 from "./mis-datos-familiares.vue?vue&type=style&index=0&id=af73555c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af73555c",
  null
  
)

export default component.exports